import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaLinkedinIn, FaWhatsapp } from "react-icons/fa";

const FloatingSocialButtons = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      setIsVisible(scrollPosition > windowHeight * 0.5);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    },
    exit: { opacity: 0 }
  };

  const itemVariants = {
    hidden: { scale: 0, rotate: -180 },
    visible: {
      scale: 1,
      rotate: 0,
      transition: {
        type: "spring",
        stiffness: 200,
        damping: 15
      }
    }
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className="fixed bottom-4 left-4 flex flex-col gap-3 z-50"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          {/* WhatsApp */}
          <motion.a
            href="https://wa.me/919175277758"
            target="_blank"
            rel="noopener noreferrer"
            variants={itemVariants}
            whileHover={{ scale: 1.1, x: -5 }}
            whileTap={{ scale: 0.9 }}
            className="relative group"
          >
            <div className="absolute inset-0 bg-[#25D366] rounded-full blur-lg opacity-50 group-hover:opacity-70 transition-opacity" />
            <div className="relative w-10 h-10 bg-[#25D366] rounded-full  flex items-center justify-center border-2 border-white">
              <FaWhatsapp className="text-white text-lg" />
            </div>
          </motion.a>

          {/* LinkedIn */}
          <motion.a
            href="https://www.linkedin.com/company/exxon-info/"
            target="_blank"
            rel="noopener noreferrer"
            variants={itemVariants}
            whileHover={{ scale: 1.1, x: -5 }}
            whileTap={{ scale: 0.9 }}
            className="relative group"
          >
            <div className="absolute inset-0 bg-[#0A66C2] rounded-full blur-lg opacity-50 group-hover:opacity-70 transition-opacity" />
            <div className="relative w-10 h-10 bg-[#0A66C2] rounded-full  flex items-center justify-center border-2 border-white">
              <FaLinkedinIn className="text-white text-lg" />
            </div>
          </motion.a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FloatingSocialButtons;